/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDashboardQueryResult } from '../../models/get-dashboard-query-result';

export interface ApiDashboardGetDashboardGet$Params {
  StartDate?: string;
  EndDate?: string;
}

export function apiDashboardGetDashboardGet(http: HttpClient, rootUrl: string, params?: ApiDashboardGetDashboardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDashboardQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiDashboardGetDashboardGet.PATH, 'get');
  if (params) {
    rb.query('StartDate', params.StartDate, {});
    rb.query('EndDate', params.EndDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDashboardQueryResult>;
    })
  );
}

apiDashboardGetDashboardGet.PATH = '/api/Dashboard/GetDashboard';
